/** Immutable list edits shared by the visual editor's list fields. */

/** Stored bodies are loosely typed — treat a missing or malformed list as empty. */
export function asArray<T = any>(value: unknown): T[] {
  return Array.isArray(value) ? value : [];
}

export function replaceAt<T>(list: T[], index: number, item: T): T[] {
  return list.map((existing, i) => (i === index ? item : existing));
}

export function removeAt<T>(list: T[], index: number): T[] {
  return list.filter((_, i) => i !== index);
}

export function insertAt<T>(list: T[], index: number, item: T): T[] {
  return [...list.slice(0, index), item, ...list.slice(index)];
}

/** Moves `from` to `to`; returns the same list when the move is out of range or a no-op. */
export function moveItem<T>(list: T[], from: number, to: number): T[] {
  if (from === to || to < 0 || to >= list.length || from < 0 || from >= list.length) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

/** Deep copy of a JSON value — lesson bodies are plain JSON. */
export function cloneJson<T>(value: T): T {
  return JSON.parse(JSON.stringify(value));
}
